export default "__VITE_ASSET__z7nDP6Gr__"